import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import * as BroadInstitute from 'help/institutions/BroadInstitute';
import {InstitutionScheduledModal} from 'help/institutions/InstitutionModalConstants';
import * as LicensedInstitution from 'help/institutions/LicensedInstitution';
import {GenentechPTDModal} from 'nav/scheduled-modal/GenentechPTDModal';
import {GenentechPTDTrainingModal} from 'nav/scheduled-modal/GenentechPTDTrainingModal';
import {TenantScheduledModal} from 'nav/scheduled-modal/ScheduledModalConstants';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';

type ScheduledModal = InstitutionScheduledModal | TenantScheduledModal;

const scheduledModals: {[s in ScheduledModal]: React.ComponentType} = {
  [InstitutionScheduledModal.BROAD_GOOGLE_AUTH_MODAL_KEY]: BroadInstitute.BroadGoogleAuthModal,
  [InstitutionScheduledModal.BROAD_SET_INSTITUTION_MODAL_KEY]: BroadInstitute.BroadSetInstitutionModal,
  [InstitutionScheduledModal.LICENSED_INSTITUTION_MODAL_KEY]:
    LicensedInstitution.LicensedInstitutionTermsModal,
  [TenantScheduledModal.GENENTECH_PTD_MODAL_KEY]: GenentechPTDModal,
  [TenantScheduledModal.GENENTECH_PTD_TRAINING_MODAL_KEY]: GenentechPTDTrainingModal,
};

export function init(): void {
  const modalKey = window.bootstrap && window.bootstrap.scheduledModalKey;

  if (!modalKey) {
    return;
  }

  const ScheduledModal = scheduledModals[modalKey as ScheduledModal];

  if (ScheduledModal) {
    LegacyModalContainer.open(modalKey, <ScheduledModal />);
    analytics.track(ANALYTICS_MODULE.NAVIGATION, 'open_scheduled_modal', {modalKey});
  }
}
